import React, { useState, useEffect } from "react";
import moment from "moment";
import { DatePicker, Table, Tag } from "antd";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import complaintActions from "../../redux/complaints/actions";
// import { CSVLink } from "react-csv";
// import { generateFilename } from "../../Helpers/Constane";
import SearchBar from "../../utils/Searchbar";
import ComplaintExport from "./ComplaintExport";
import "./complaints.scss";

const { getComplaintsData } = complaintActions;

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a?.key - b?.key,
    width: 100, // Fixed width
  },
  {
    title: "DATE-TIME",
    dataIndex: "date",
    sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
    width: 100, // Fixed width
    render: (text, record) => (
      <>
        <p className="m-0 p-0">
          {moment(record?.createdAt)?.format("DD MMMM YYYY")}
        </p>
        <p className="m-0 p-0">
          {moment(record?.createdAt)?.format("hh:mm:ss A")}
        </p>
      </>
    ),
  },
  {
    title: "COMPLAINT ID",
    dataIndex: "complaint_id",
    width: 100, // Fixed width
  },
  {
    title: "COMPLAINT TYPE",
    dataIndex: "complaint_type",
    width: 100, // Fixed width
  },

  {
    title: "STATUS",
    dataIndex: "status",
    width: 100, // Fixed width
  },

  {
    title: "DISPOSITION",
    dataIndex: "disposition",
    width: 100, // Fixed width
  },
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    width: 100, // Fixed width
  },
];
function Complaints() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const { complaintsData, totalData, loading } = useSelector(
    (state) => state.complaintReducer
  );

  const profileData = useSelector((state) => state.authReducer.profileData);
  console.log(profileData?.orgId, "profile data");

  useEffect(() => {
    if (profileData) {
      dispatch(getComplaintsData(1, 10, "", "", "", profileData?.orgId));
    }
    // dispatch(getComplaintsData());
  }, [dispatch, profileData]);

  var data =
    complaintsData.complaints &&
    complaintsData.complaints.length > 0 &&
    complaintsData.complaints.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        complaint_id: items?.response?.TicketResp[0]
          ?.ticketId || <Tag>{""}</Tag>,
        complaint_type: items?.response?.TicketResp[0]?.ticketType,

        description: (
          <Tag
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            className="draft"
          >
            {" "}
            {items?.request.description ? (
              <textarea
                rows={2}
                readOnly
                style={{
                  outline: "none",
                  border: "none",

                  resize: "verticle",
                  overflow: "hidden", // Hide scrollbars
                  whiteSpace: "pre-wrap",

                  fontSize: "14px",
                  color: "#333",
                }}
                value={items?.request.description || ""} // Fallback for undefined values
              />
            ) : (
              <Tag>{""}</Tag>
            )}
          </Tag>
        ),

        disposition: (
          <Tag
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            className="draft"
          >
            {" "}
            {items?.request.disposition ? (
              <textarea
                rows={2}
                readOnly
                style={{
                  outline: "none",
                  border: "none",

                  resize: "verticle",
                  overflow: "hidden", // Hide scrollbars
                  whiteSpace: "pre-wrap",

                  fontSize: "14px",
                  color: "#333",
                }}
                value={items?.request.disposition || ""} // Fallback for undefined values
              />
            ) : (
              <Tag>{""}</Tag>
            )}
          </Tag>
        ),

        date: (
          <>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("hh:mm:ss A")}
            </p>
          </>
        ),

        // items?.cuResponse?.toLowerCase() === "successful"

        createdAt: items.createdAt || "",
        // status: items?.response?.TicketResp[0]?.responseReason || "",
        status: (
          <Tag
            color={
              items?.response?.TicketResp[0]?.ticketStatus === "ASSIGNED"
                ? "green"
                : "orange"
            }
          >
            {items?.response?.TicketResp[0]?.ticketStatus || ""}
          </Tag>
        ),
      };
    });

  let timeoutId;
  const handleFilterChange = (e) => {
    console.log("mmmmm", e.target.value);
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }

    timeoutId = setTimeout(() => {
      if (complaintsData?.complaints?.length >= 0 && profileData) {
        dispatch(getComplaintsData(0, 10, value, "", "", profileData?.orgId));
      }
    }, 1000);
  };

  const handlePageChange = async (pagination, sofilters, rter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });

    if (fromDate && toDate) {
      dispatch(
        getComplaintsData(
          current,
          pageSize,
          "",
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD")
        )
      );
    } else {
      dispatch(
        getComplaintsData(current, pageSize, "", "", "", profileData?.orgId)
      );
    }
  };

  //  const handleFromDateChange = (date) => {
  //   setFromDate(date);
  //   };
   const handleFromDateChange = (date) => {
      if (
        date?.isSame(moment(), "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setFromDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else {
        setFromDate(date);
      }
      if (date > toDate) {
        setToDate(null);
      }
    };

    const handleToDateChange = (date) => {
      const now = moment();
      let adjustedDate = date?.clone();
    
      // Prevent future dates
      if (adjustedDate?.isAfter(now, "day")) {
        adjustedDate = now.clone();
      }
    
      // If selected date is today
      if (adjustedDate?.isSame(now, "day")) {
        if (adjustedDate.isAfter(now)) {
          adjustedDate = adjustedDate.set({
            hour: now.hour(),
            minute: now.minute(),
            second: now.second(),
          });
        }
      }
    
      // If it's same as fromDate and time is 00:00:00, set to end of day
      if (
        adjustedDate?.isSame(fromDate, "day") &&
        adjustedDate.hour() === 0 &&
        adjustedDate.minute() === 0 &&
        adjustedDate.second() === 0
      ) {
        adjustedDate = adjustedDate.set({ hour: 23, minute: 59, second: 59 });
      }
    
      setToDate(adjustedDate);
    
      // If fromDate is after new toDate, clear it
      if (adjustedDate && fromDate && adjustedDate.isBefore(fromDate)) {
        setFromDate(null);
      }
    
      // Format and dispatch
      const fromSendDate = fromDate?.format("YYYY-MM-DDTHH:mm:ss.000+05:30");
      const toSendDate = adjustedDate?.format("YYYY-MM-DDTHH:mm:ss.000+05:30");
    
      if (fromSendDate && toSendDate) {
        dispatch(getComplaintsData(1, 10, "", fromSendDate, toSendDate));
      } else {
        dispatch(getComplaintsData(1, 10));
      }
    };

  const disabledToDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

    const disabledTime = (currentDate) => {
      const now = moment();
      if (currentDate.isSame(now, 'day')) {
        return {
          disabledHours: () =>
            Array.from({ length: 24 }, (_, i) => i).filter(
              (hour) => hour > now.hour()
            ),
          disabledMinutes: (selectedHour) => {
            if (selectedHour === now.hour()) {
              return Array.from({ length: 60 }, (_, i) => i).filter(
                (minute) => minute > now.minute()
              );
            }
            return [];
          },
          disabledSeconds: () => [],
        };
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      };
    };

  const exportData =
    complaintsData.complaints &&
    complaintsData.complaints.length > 0 &&
    complaintsData.complaints.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        complaint_id:
          items?.response?.TicketResp[0]?.ticketId || "",
        complaint_type: items?.response?.TicketResp[0]?.ticketType,
        // assigned: items?.response?.TicketResp[0]?.assigned || "",
        remarks: items?.response?.TicketResp[0]?.remarks || "",
        date: moment(items.createTime).format("DD MMMM YYYY"),
        status: items?.response?.TicketResp[0]?.responseReason,
      };
    });

  return (
    <div className="mainContain">
      <h1 className="transaction">Complaints</h1>

      <div className="datesearchFi">
        <div className="">
          <SearchBar onChange={handleFilterChange} />
        </div>
        <div className="inputfatef">
          <div>
            {/* <span>From (DD-MM-YYYY)</span> */}
            <DatePicker
              value={fromDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleFromDateChange}
              disabledDate={disabledDate}
              format="DD-MM-YYYY HH:mm:ss"
              showTime
              showNow={false}
              placeholder="From (DD-MM-YYYY HH:mm:ss)" // Placeholder added here
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
          <div>
            {/* <span>To (DD-MM-YYYY)</span> */}
            <DatePicker
              value={toDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleToDateChange}
              disabledDate={disabledToDate}
              format="DD-MM-YYYY HH:mm:ss"
              showTime={{
                format: "HH:mm:ss",
                disabledTime: disabledTime
              }}
              showNow={false}
              placeholder="To (DD-MM-YYYY HH:mm:ss)" // Placeholder added here
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
        </div>
      </div>
      {data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <ComplaintExport />
        </div>
      )}

      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          scroll={{ x: 600 }}
          pagination={{
            total: totalData,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50"],
          }}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Complaints;
